import React from 'react'
import { useSearchParams } from 'react-router-dom'
import PageLayout from '../common/layout/PageLayout'
import useAuth from '../../hooks/useAuth'
import AdminUsersFilters from './adminUsers/AdminUsersFilters'
import AdminUsersTable from './adminUsers/AdminUsersTable'
import AdminUserModals from './adminUsers/AdminUserModals'
import useAdminUsersData from './adminUsers/useAdminUsersData'
import './AdminUsers.css'

function AdminUsers() {
  const { user } = useAuth()
  const [searchParams] = useSearchParams()
  const adminUsersData = useAdminUsersData({ searchParams })

  if (adminUsersData.loading)
    return (
      <PageLayout title="Manage Users" noCard={true}>
        <p>Loading users...</p>
      </PageLayout>
    )

  if (adminUsersData.error)
    return (
      <PageLayout title="Manage Users" noCard={true}>
        <p className="text-danger">Error: {adminUsersData.error}</p>
      </PageLayout>
    )

  return (
    <PageLayout title="Manage Users" noCard={true}>
      <div className="admin-users-container">
        <AdminUsersFilters
          activeFilter={adminUsersData.activeFilter}
          setActiveFilter={adminUsersData.setActiveFilter}
          stats={adminUsersData.stats}
          searchTerm={adminUsersData.searchTerm}
          setSearchTerm={adminUsersData.setSearchTerm}
        />

        {adminUsersData.filteredAndSortedUsers.length === 0 && (
          <div className="admin-users-empty-state">
            <i className="bi bi-search"></i>
            {adminUsersData.searchTerm ? (
              <>
                <h5>No users found</h5>
                <p className="text-muted">
                  No users match your search "{adminUsersData.searchTerm}". Try
                  a different search term.
                </p>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => adminUsersData.setSearchTerm('')}
                >
                  Clear Search
                </button>
              </>
            ) : (
              <>
                <h5>No active users</h5>
                <p className="text-muted">
                  There are currently no active users in the system.
                </p>
              </>
            )}
          </div>
        )}

        {adminUsersData.filteredAndSortedUsers.length > 0 && (
          <AdminUsersTable
            users={adminUsersData.filteredAndSortedUsers}
            user={user}
            impersonating={adminUsersData.impersonating}
            sortColumn={adminUsersData.sortColumn}
            sortDirection={adminUsersData.sortDirection}
            onSort={adminUsersData.handleSort}
            onMakeAdmin={adminUsersData.handleMakeAdmin}
            onImpersonate={adminUsersData.handleImpersonate}
            onDelete={adminUsersData.handleDelete}
            onResetPassword={adminUsersData.handleResetPasswordClick}
            onEdit={adminUsersData.handleStartEdit}
            editingUserId={adminUsersData.editingUserId}
            editFormData={adminUsersData.editFormData}
            setEditFormData={adminUsersData.setEditFormData}
            editErrors={adminUsersData.editErrors}
            onSave={adminUsersData.handleSaveEdit}
            onCancel={adminUsersData.handleCancelEdit}
            isSaving={adminUsersData.isSaving}
          />
        )}

        <AdminUserModals
          showResetModal={adminUsersData.showResetModal}
          resetUser={adminUsersData.resetUser}
          tempPassword={adminUsersData.tempPassword}
          onCloseResetModal={adminUsersData.handleCloseResetModal}
          onGeneratePassword={adminUsersData.handleGeneratePassword}
          showMakeAdminModal={adminUsersData.showMakeAdminModal}
          userToMakeAdmin={adminUsersData.userToMakeAdmin}
          onCloseMakeAdminModal={adminUsersData.handleCloseMakeAdminModal}
          onConfirmMakeAdmin={adminUsersData.handleConfirmMakeAdmin}
          showImpersonateModal={adminUsersData.showImpersonateModal}
          impersonateTarget={adminUsersData.impersonateTarget}
          impersonateReason={adminUsersData.impersonateReason}
          setImpersonateReason={adminUsersData.setImpersonateReason}
          impersonating={adminUsersData.impersonating}
          onCloseImpersonateModal={adminUsersData.handleCloseImpersonateModal}
          onConfirmImpersonate={adminUsersData.handleConfirmImpersonate}
        />
      </div>
    </PageLayout>
  )
}

export default AdminUsers
